export default class BindItemDatasourceRequest {
  datasourceId: string;

  constructor(datasourceId: string) {
    this.datasourceId = datasourceId || '';
  }
}
